module.exports = __webpack_public_path__ + "img/32.dbd2aeb5.jpg";